import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';

export default {
  install(Vue, options) {
    Vue.prototype.getPdfByPage = async function(id, direction, compress) {
      try {
        const title = this.htmlTitle;
        const element = document.querySelector('#' + id);
        if (!element) {
          console.error(`Element with id ${id} not found`);
          return;
        }
        
        // 获取原元素宽度和固定宽高比
        const rect = element.getBoundingClientRect();
        const originalWidth = rect.width || element.offsetWidth;
        const fixedAspectRatio = 1 / Math.sqrt(2);
        
        if (!direction) {
          direction = 'p';
        }
        
        const PDF = new JsPDF(direction, 'pt', 'a4');
        const pageWidth = PDF.internal.pageSize.getWidth();
        const pageHeight = PDF.internal.pageSize.getHeight();
        const margin = 20; // 页边距
        const pdfContentMaxWidth = pageWidth - 2 * margin;

        // 提前创建临时容器和克隆元素，基于克隆后的实际高度计算分页
        const tempContainer = document.createElement('div');
        tempContainer.style.position = 'absolute';
        tempContainer.style.left = '-9999px';
        tempContainer.style.width = `${originalWidth}px`;
        tempContainer.style.backgroundColor = 'white';
        tempContainer.style.boxSizing = 'border-box';
        tempContainer.style.overflow = 'hidden';

        const contentClone = element.cloneNode(true);
        contentClone.style.position = 'relative';
        contentClone.style.top = '0px';
        contentClone.style.width = '100%';
        contentClone.style.margin = '0';
        contentClone.style.padding = '0';
        contentClone.style.boxSizing = 'border-box';

        tempContainer.appendChild(contentClone);
        document.body.appendChild(tempContainer);

        // 基于克隆元素的实际渲染高度重新计算分页
        const clonedHeight = contentClone.scrollHeight;
        const clonedPageContentMaxHeight = Math.floor(originalWidth / fixedAspectRatio);
        const clonedPageCount = Math.ceil(clonedHeight / clonedPageContentMaxHeight);
        const clonedActualPageCount = clonedPageCount > 0 ? clonedPageCount : 1;

        let addedPageNum = 0;
        
        for (let page = 0; page < clonedActualPageCount; page++) {
          const currentOffsetTop = page * clonedPageContentMaxHeight;
          const currentPageHeight = Math.min(clonedPageContentMaxHeight, clonedHeight - currentOffsetTop);
          
          if (currentPageHeight <= 0) break;
          
          // 调整克隆元素位置和容器高度以截取当前页
          contentClone.style.top = `-${currentOffsetTop}px`;
          tempContainer.style.height = `${currentPageHeight}px`;
          
          const canvas = await html2canvas(tempContainer, {
            allowTaint: true,
            dpi: compress ? 150 : 300,
            scale: compress ? 2 : 4,
            useCORS: true,
            logging: false,
            backgroundColor: '#FFFFFF',
            width: originalWidth,
            height: currentPageHeight
          });
          
          // 校验canvas内容【原有代码不变】
          const ctx = canvas.getContext('2d');
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const hasContent = imageData.data.some(pixel => pixel !== 255);
          if (!hasContent) continue;
          
          // 【核心修改1】计算canvas实际宽高比（原有逻辑保留）
          const canvasAspectRatio = canvas.height / canvas.width;
          const pdfDisplayWidth = pdfContentMaxWidth;
          const pdfDisplayHeight = pdfDisplayWidth * canvasAspectRatio;
          
          // 【核心修改2】将垂直居中改为顶部对齐：yPos直接等于页边距（靠上显示）
          // 原居中逻辑：const yPos = margin + (availableHeight - pdfDisplayHeight) / 2;
          // 新靠上逻辑：直接从页边距的顶部位置开始渲染
          const yPos = margin; 
          
          // 添加PDF页面【原有代码不变】
          if (addedPageNum > 0) PDF.addPage();
          PDF.addImage(
            canvas, 
            'JPEG', 
            margin,        // x轴：左边距（不变）
            yPos,          // y轴：上边距（靠上显示）
            pdfDisplayWidth,
            pdfDisplayHeight
          );
          
          addedPageNum++;
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        // 清理临时容器
        document.body.removeChild(tempContainer);
        
        // 兜底删除空白页【原有代码不变】
        if (PDF.internal.getNumberOfPages() > addedPageNum) {
          PDF.deletePage(PDF.internal.getNumberOfPages());
        }
        
        PDF.save(title + '.pdf');
        
      } catch (error) {
        console.error('生成PDF失败:', error);
        throw error;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/htmlToPdfByPage.js